import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "线索线索ID", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-left":"5px","color":"#7f7f7f"} }, "(取消关联请删除销售线索ID)", -1)

import { ref } from 'vue'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { clueRelate } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { Modal } from 'ant-design-vue'

const __default__ = { name: 'relevanceClue' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const form = ref<any>({})
const emit = __emit
const showModal = (row: ClueManage) => {
  form.value = {
    clueId: row.clueId,
    customerName: row.customerName,
    acceptorClueId: row?.track?.acceptorClueId
  }
  visible.value = true
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    postData(false)
  })
}
const postData = (occupyConfirmFlag: boolean) => {
  loading.value = true
  const p: any = {}
  clueRelate(
    {
      ...form.value,
      occupyConfirmFlag
    },
    { custom: { errorMsg: false } }
  )
    .then((res) => {
      if (res.code === 13000069) {
        DcConfirm.warning({
          title: '操作提示！',
          content: res.message,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            postData(true)
          }
        })
      } else if (res.code === 200) {
        if (form.value.acceptorClueId) {
          DcMessage.success('关联线索成功')
        } else {
          DcMessage.success('取消关联成功')
        }
        visible.value = false
        emit('success')
      } else {
        DcMessage.error(res.message)
      }
    })
    .finally(() => {
      loading.value = false
    })
}
__expose({ showModal })

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "关联线索",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: form.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "clueId",
                label: "客户名称",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: form.value.customerName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerName) = $event)),
                    placeholder: "请输入",
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { name: "acceptorClueId" }, {
                label: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_CosInput, {
                    value: form.value.acceptorClueId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.acceptorClueId) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})